import "./Linker-with-a.component.scss";

import { memo } from "react";
import { useTranslation } from "react-i18next";

const LinkerWithA = props => {
  const {
    label,
    href,
    className,
    onClick,
    ...other
  } = props;

  const { t } = useTranslation();

  return (
    <a
      href={href}
      className={`linker ${className}`}
      onClick={onClick}
      {...other}
    >
      {t(label)}
    </a>
  );
};

export default memo(LinkerWithA);
